import clsx from "classnames";
import classes from "./styles.module.scss";

import Link from 'next/link';

export default function ResourceCard({ resource, className }) {
  
  return (
    <Link href={false ? resource.report : "/blog/" + resource.url_slug} target={false ? "_blank" : "_self"} passHref>
      <div className={clsx(className, classes.resource_card)}>
        <img className={classes.resource_image} src={resource.image} alt={resource.title}></img>
        <div className={classes.resource_detail}>
          <div className={classes.detail_card}>
            <div className={classes.header}>
              <div className={classes.tag}>{resource.category}</div>
              {
                resource.minutes &&
                <div className={classes.read_time}>
                  <img src="/icons/time-clock.png" alt="time-clock"></img>
                  <div className={classes.duration}>{`${resource.minutes} min read`}</div>
                </div>
              }
            </div>
            <div className={classes.title}>{resource.title}</div>
            {
              resource.category === 'Events' &&
              <div className={classes.contacts}>
                <div><img src="/icons/location_color.png" alt="location"/><span>{resource.location}</span></div>
              </div>
            }
          </div>
        </div>
      </div>
    </Link>
  );
}

ResourceCard.defaultProps = {
  className: "",
};
